/* eslint-disable */
import { lazy } from "react";

// Lazy-loaded page components
const Home = lazy(() => import("../pages/Home/Home"));
const DoctorList = lazy(() => import("pages/DoctorList/DoctorList"));
const DoctorsDetails = lazy(() =>
  import("pages/DoctorsDetails/DoctorsDetails")
);
const DoctorDetailsPrime = lazy(() =>
  import("pages/DoctorsDetails/DoctorDetailsPrime")
);
const ClinicList = lazy(() => import("pages/ClinicList/ClinicList"));
const ClinicDetails = lazy(() => import("pages/ClinicDetails/ClinicDetails"));
const ClinicDetailsPremium = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPremium")
);
const ClinicDetailsPrime = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrime")
);
const ClinicDetailsPrimeServices = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeServices")
);
const ClinicDetailsPrimeTeam = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeTeam")
);
const ClinicDetailsPrimeSuccess = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeSuccess")
);
const ClinicDetailsPrimeSuccessDetails = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeSuccessDetails")
);

const ClinicDetailsPrimeArticlesDetails = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeArticlesDetails")
);

const ClinicDetailsPrimeArticles = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeArticles")
);
const ClinicDetailsPrimeReviews = lazy(() =>
  import("pages/ClinicDetails/ClinicDetailsPrimeReviews")
);
const PharmacistList = lazy(() =>
  import("pages/PharmacistList/PharmacistList")
);
const ArticleList = lazy(() => import("pages/ArticleList/ArticleList"));
const ArticleDetails = lazy(() =>
  import("pages/ArticleDetails/ArticleDetails")
);
const MeetingDetails = lazy(() =>
  import("pages/MeetingDetails/MeetingDetails")
);
const SuccessStoryList = lazy(() =>
  import("pages/SuccessStoryList/SuccessStoryList")
);
const SuccessStoryDetails = lazy(() =>
  import("pages/SuccessStoryDetails/SuccessStoryDetails")
);
const EventList = lazy(() => import("pages/EventList/EventList"));
const EventDetails = lazy(() => import("pages/EventDetails/EventDetails"));
const GroupList = lazy(() => import("pages/GroupList/GroupList"));
const GroupDetails = lazy(() => import("pages/GroupDetails/GroupDetails"));
const ProductList = lazy(() => import("pages/ProductList/ProductList"));
const ProductDetails = lazy(() =>
  import("pages/ProductDetails/ProductDetails")
);
const CourseList = lazy(() => import("pages/CourseList/CourseList"));
const CourseDetails = lazy(() => import("pages/CourseDetails/CourseDetails"));
const ChallengesList = lazy(() =>
  import("pages/ChallengesList/ChallengesList")
);
const ChallengeDetails = lazy(() =>
  import("pages/ChallengeDetails/ChallengeDetails")
);
const BookingStep1 = lazy(() => import("pages/BookingStep1/BookingStep1"));
const BookingStep2 = lazy(() => import("pages/BookingStep2/BookingStep2"));
const BookingStep3 = lazy(() => import("pages/BookingStep3/BookingStep3"));
const BookingStep4 = lazy(() => import("pages/BookingStep4/BookingStep4"));
const BookingStep5 = lazy(() => import("pages/BookingStep5/BookingStep5"));
const BookingStep6 = lazy(() => import("pages/BookingStep6/BookingStep6"));
const CompanyLanding = lazy(() =>
  import("pages/CompanyLanding/CompanyLanding")
);
const DoctorsLanding = lazy(() =>
  import("pages/DoctorsLanding/DoctorsLanding")
);
const CoursesLanding = lazy(() =>
  import("pages/CoursesLanding/CoursesLanding")
);
const MyAppointments = lazy(() =>
  import("pages/MyAppointments/MyAppointments")
);
const MyAppointmentCalendar = lazy(() =>
  import("pages/MyAppointmentCalendar/MyAppointmentCalendar")
);
const MyConditions = lazy(() => import("pages/MyConditions/MyConditions"));
const MyMedications = lazy(() => import("pages/MyMedications/MyMedications"));
const MyAllergies = lazy(() => import("pages/MyAllergies/MyAllergies"));
const MyImmunizations = lazy(() =>
  import("pages/MyImmunizations/MyImmunizations")
);
const MyResults = lazy(() => import("pages/MyResults/MyResults"));
const MyPrepcriptions = lazy(() =>
  import("pages/MyPrepcriptions/MyPrepcriptions")
);
const MyTreatments = lazy(() => import("pages/MyTreatments/MyTreatments"));
const MyTreatmentCalendar = lazy(() =>
  import("pages/MyTreatmentCalendar/MyTreatmentCalendar")
);
const MyOrders = lazy(() => import("pages/MyOrders/MyOrders"));
const BloodPressure = lazy(() =>
  import("pages/MyVitals/BloodPressure/BloodPressure.jsx")
);
const HeartRate = lazy(() => import("pages/MyVitals/HeartRate/HeartRate.jsx"));
const Temperature = lazy(() =>
  import("pages/MyVitals/Temperature/Temperature.jsx")
);
const OxygenSaturation = lazy(() =>
  import("pages/MyVitals/OxygenSaturation/OxygenSaturation.jsx")
);
const RespirationRate = lazy(() =>
  import("pages/MyVitals/RespirationRate/RespirationRate.jsx")
);
const Height = lazy(() => import("pages/MyVitals/Height/Height.jsx"));
const HeadCircumference = lazy(() =>
  import("pages/MyVitals/HeadCircumference/HeadCircumference.jsx")
);
const Weight = lazy(() => import("pages/MyVitals/Weight/Weight.jsx"));
const PharmacyDetails = lazy(() =>
  import("pages/PharmacyDetails/PharmacyDetails")
);
const Conversation = lazy(() => import("pages/Conversation/Conversation.jsx"));
const Cart = lazy(() => import("pages/Cart/Cart"));
const BillingAddress = lazy(() =>
  import("pages/BillingAddress/BillingAddress")
);
const Checkout = lazy(() => import("pages/Checkout/Checkout"));
const PaymentSuccess = lazy(() => import("pages/Payment/PaymentSuccess.jsx"));
const PaymentFailure = lazy(() => import("pages/Payment/PaymentFailure.jsx"));

const MailSent = lazy(() => import("pages/MailConversation/Sent/MailSent"));
const MailRecieved = lazy(() =>
  import("pages/MailConversation/Recieved/MailRecieved")
);

const CvBuilder = lazy(() => import("pages/CvBuilder/CvBuilder"));

const Logout = lazy(() => import("pages/Auth/Logout"));

// Common routes shared by public and protected
const commonRoutes = [
  { path: "/", component: Home },
  { path: "/doctorlist", component: DoctorList },
  { path: "/doctor/details/:id", component: DoctorsDetails },
  { path: "/cliniclist", component: ClinicList },
  { path: "/clinic/details/:id", component: ClinicDetails },
  { path: "/clinic/details/premium/:id", component: ClinicDetailsPremium },
  { path: "/articlelist", component: ArticleList },
  { path: "/article/details/:id", component: ArticleDetails },
  { path: "/successstorylist", component: SuccessStoryList },
  { path: "/successstory/details/:id", component: SuccessStoryDetails },
  { path: "/eventlist", component: EventList },
  { path: "/event/details/:id", component: EventDetails },
  { path: "/productlist", component: ProductList },
  { path: "/product/details/:id", component: ProductDetails },
  { path: "/grouplist", component: GroupList },
  { path: "/group/details/:id", component: GroupDetails },
  { path: "/challengeslist", component: ChallengesList },
  { path: "/challenge/details/:id", component: ChallengeDetails },
  { path: "/companyLanding", component: CompanyLanding },
  { path: "/doctorsLanding", component: DoctorsLanding },
  { path: "/coursesLanding", component: CoursesLanding },
  { path: "/meeting/details/:id", component: MeetingDetails },
];

// Public-only routes
const publicRoutes = [
  ...commonRoutes,
  { path: "/pharmacistlist", component: PharmacistList },
  { path: "/courselist", component: CourseList },
  { path: "/pharmacy/details/:id", component: PharmacyDetails },
  { path: "/coursedetails", component: CourseDetails },
  { path: "/bookingStep1", component: BookingStep1 },
  { path: "/bookingStep2", component: BookingStep2 },
  { path: "/bookingStep3", component: BookingStep3 },
  { path: "/bookingStep4", component: BookingStep4 },
  { path: "/bookingStep5", component: BookingStep5 },
  { path: "/bookingStep6", component: BookingStep6 },
];

// Protected-only routes
const protectedRoutes = [
  ...commonRoutes,
  { path: "/doctor/details/prime/:id", component: DoctorDetailsPrime },
  { path: "/clinic/details/prime/about/:id", component: ClinicDetailsPrime },
  {
    path: "/clinic/details/prime/services/:id",
    component: ClinicDetailsPrimeServices,
  },
  { path: "/clinic/details/prime/team/:id", component: ClinicDetailsPrimeTeam },
  {
    path: "/clinic/details/prime/success/:id",
    component: ClinicDetailsPrimeSuccess,
  },
  {
    path: "/clinic/details/prime/success/details/:id/:storyid",
    component: ClinicDetailsPrimeSuccessDetails,
  },
  {
    path: "/clinic/details/prime/articles/:id",
    component: ClinicDetailsPrimeArticles,
  },
  {
    path: "/clinic/details/prime/articles/details/:id/:articleid",
    component: ClinicDetailsPrimeArticlesDetails,
  },
  {
    path: "/clinic/details/prime/reviews/:id",
    component: ClinicDetailsPrimeReviews,
  },
  { path: "/myappointments", component: MyAppointments },
  { path: "/myappointmentcalendar", component: MyAppointmentCalendar },
  { path: "/myconditions", component: MyConditions },
  { path: "/mymedications", component: MyMedications },
  { path: "/myallergies", component: MyAllergies },
  { path: "/myimmunizations", component: MyImmunizations },
  { path: "/myresults", component: MyResults },
  { path: "/myprepcriptions", component: MyPrepcriptions },
  { path: "/mytreatments", component: MyTreatments },
  { path: "/mytreatmentcalendar", component: MyTreatmentCalendar },
  { path: "/myorders", component: MyOrders },
  { path: "/bloodpressure", component: BloodPressure },
  { path: "/heartrate", component: HeartRate },
  { path: "/temperature", component: Temperature },
  { path: "/oxygensaturation", component: OxygenSaturation },
  { path: "/respirationrate", component: RespirationRate },
  { path: "/height", component: Height },
  { path: "/headcircumference", component: HeadCircumference },
  { path: "/weight", component: Weight },
  { path: "/cart", component: Cart },
  { path: "/billings", component: BillingAddress },
  { path: "/checkout", component: Checkout },
  { path: "/payment/success", component: PaymentSuccess },
  { path: "/payment/failure", component: PaymentFailure },

  //cv builder
  { path: "/cvbuilder/:jobid", component: CvBuilder },

  // conversation
  { path: "/conversation", component: Conversation },
  { path: "/conversation/:conversationtype/:roomid", component: Conversation },
  {
    path: "/conversation/:conversationtype/:roomid/:moduleslug",
    component: Conversation,
  },
  {
    path: "/conversation/:conversationtype/:roomid/:moduleslug/:componentid",
    component: Conversation,
  },
  {
    path: "/conversation/:conversationtype/:roomid/:moduleslug/:componentid/:componentname",
    component: Conversation,
  },

  {
    path: "/conversation/:conversationtype/:roomid/:moduleslug/:componentid/:componentname",
    component: Conversation,
  },
  {
    path: "/conversation/:conversationtype/:roomid/:componentslug",
    component: Conversation,
  },

  {
    path: "/conversation/:conversationtype/:roomid/:componentslug/:componentid",
    component: Conversation,
  },
  {
    path: "/conversation/:conversationtype/:roomid/:componentslug/:componentid/:componenttitle",
    component: Conversation,
  },
  { path: "/mail/sent", component: MailSent },
  { path: "/mail/recieved", component: MailRecieved },
  { path: "/logout", component: Logout },
];

export { publicRoutes, protectedRoutes };
